document.addEventListener('DOMContentLoaded', function() {
    const selectorContainer = document.getElementById('BoxSelectorContainer');
    const widgetContainer = document.getElementById('AppWidgetContainer');
    const giftGrid = document.getElementById('GiftSelectionGrid');
    const addToCartButton = document.getElementById('addToCartButton');
    const itemCountSpan = document.getElementById('item-count');
    const itemMaxSpan = document.getElementById('item-max');
    const itemTotalSpan = document.getElementById('item-total');
    const summaryList = document.getElementById('summary-items-list');
    const boxTypeSummary = document.getElementById('box-type-summary');

    let selectedBox = null;
    let selectedGifts = new Map(); // Stores {variantId: {qty: 1, price: 1000, name: 'Gift'}}
    let maxItems = 0;
    let giftProducts = {}; // Store product data for quick lookup

    // --- STEP 1: INITIALIZE BUTTONS ---
    const boxButtons = document.querySelectorAll('.box-buttons-wrapper .button');
    boxButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const boxId = e.currentTarget.getAttribute('data-box-id');
            const sizeText = e.currentTarget.textContent;
            
            if (!boxId) return;

            selectedBox = {
                id: boxId,
                name: sizeText.split('(')[0].trim(), // e.g., "Small Box"
                limit: sizeText.includes('Small') ? 5 : 10 // Sets the limit
            };
            
            // Reset state
            selectedGifts.clear();
            maxItems = selectedBox.limit;
            
            // Update UI
            itemMaxSpan.textContent = maxItems;
            boxTypeSummary.textContent = selectedBox.name;
            selectorContainer.style.display = 'none';
            widgetContainer.style.display = 'flex';
            
            // Proceed to Step 2: Load Gift Items
            loadGiftItems();
        });
    });

    // --- STEP 2: LOAD GIFTS (Fetches all products tagged 'gift-item') ---
    function loadGiftItems() {
        giftGrid.innerHTML = '<p>Fetching items...</p>';
        
        // Ensure your gift products are tagged 'gift-item' or change the URL below
        // NOTE: We fetch variants, title, handle, tags, and rely on the images array being present.
        fetch('/collections/all/products.json?limit=50&fields=variants,title,featured_image,handle,tags')
            .then(response => response.json())
            .then(data => {
                giftGrid.innerHTML = '';
                giftProducts = {}; 
                
                // Filter only products tagged 'gift-item'
                const gifts = data.products.filter(p => p.tags.includes('gift-item'));
                
                if (gifts.length === 0) {
                     giftGrid.innerHTML = '<p>No gift items found. Please ensure products are tagged "gift-item".</p>';
                     return;
                }

                gifts.forEach(product => {
                    const variant = product.variants[0]; // Assumes single variant per gift
                    
                    // Store for summary lookup
                    giftProducts[variant.id] = { name: product.title, price: parseFloat(variant.price) * 100 };

                    // ----------------------------------------------------------------------------------
                    // 🌟 IMAGE URL FIX: Use the variant's featured image OR the product's first image 🌟
                    // ----------------------------------------------------------------------------------
                    let imageSrc = '';
                    
                    if (product.featured_image && product.featured_image.src) {
                        // Priority 1: Use the featured_image (if available)
                        imageSrc = product.featured_image.src;
                    } else if (product.images && product.images.length > 0) {
                        // Priority 2: Use the first image in the product's image array if featured_image is null
                        imageSrc = product.images[0].src;
                    }

                    if (imageSrc) {
                        // Apply the _300x resize filter using string replacement
                        imageSrc = imageSrc.replace(/(\.png|\.jpg|\.jpeg|\.gif)$/i, '_300x$1');
                    }
                    // ----------------------------------------------------------------------------------

                    const itemHTML = `
                        <div class="gift-item" data-id="${variant.id}">
                            <img src="${imageSrc}" alt="${product.title}">
                            <h4 style="color:#000000;">${product.title}</h4>
                            <p>$${parseFloat(variant.price).toFixed(2)}</p>
                            <button class="add-gift-btn button">Add</button>
                            <button class="remove-gift-btn button" style="display:none;">Remove</button>
                            <span class="qty-counter"></span>
                        </div>
                    `;
                    giftGrid.insertAdjacentHTML('beforeend', itemHTML);
                });

                // Attach event listeners to the new buttons
                document.querySelectorAll('.add-gift-btn').forEach(button => {
                    button.addEventListener('click', (e) => handleGiftSelection(e, 1)); 
                });
                document.querySelectorAll('.remove-gift-btn').forEach(button => {
                    button.addEventListener('click', (e) => handleGiftSelection(e, -1)); 
                });

                updateSummary(); 
            });
    }

    // --- STEP 3: HANDLE SELECTION LOGIC ---
    function handleGiftSelection(e, change) {
        const itemElement = e.target.closest('.gift-item');
        const variantId = itemElement.getAttribute('data-id');
        
        let currentCount = Array.from(selectedGifts.values()).reduce((sum, item) => sum + item.qty, 0);
        let newCount = currentCount + change;
        
        // Get data from lookup
        let price = giftProducts[variantId].price;
        let name = giftProducts[variantId].name;

        if (newCount > maxItems) {
            alert(`You can only select a maximum of ${maxItems} items for the ${selectedBox.name}!`);
            return;
        }

        let itemData = selectedGifts.get(variantId) || { qty: 0, price: price, name: name };
        itemData.qty += change;

        if (itemData.qty <= 0) {
            selectedGifts.delete(variantId);
        } else {
            selectedGifts.set(variantId, itemData);
        }

        updateSummary();
    }

    // --- STEP 4: UPDATE UI & CHECKOUT ---
    function updateSummary() {
        let currentCount = 0;
        let totalPrice = 0;
        summaryList.innerHTML = ''; 

        selectedGifts.forEach((item, variantId) => {
            currentCount += item.qty;
            totalPrice += (item.price / 100) * item.qty;
            
            // Update item card UI
            const itemElement = document.querySelector(`.gift-item[data-id="${variantId}"]`);
            if (itemElement) {
                itemElement.querySelector('.qty-counter').textContent = ` (x${item.qty})`;
                itemElement.querySelector('.remove-gift-btn').style.display = 'inline-block';
            }

            // Update sidebar summary list
            const listItem = document.createElement('p');
            listItem.textContent = `${item.name} x${item.qty} ($${((item.price / 100) * item.qty).toFixed(2)})`;
            summaryList.appendChild(listItem);
        });
        
        // Update visibility for items not selected
        document.querySelectorAll('.gift-item').forEach(itemElement => {
            const id = itemElement.getAttribute('data-id');
            if (!selectedGifts.has(id)) {
                itemElement.querySelector('.remove-gift-btn').style.display = 'none';
                itemElement.querySelector('.qty-counter').textContent = '';
            }
        });

        itemCountSpan.textContent = currentCount;
        itemTotalSpan.textContent = `$${totalPrice.toFixed(2)}`;

        // Enable/disable the Add to Cart button
        addToCartButton.disabled = currentCount === 0;
    }

    // --- STEP 5: ADD TO CART (Sends to Shopify Cart API) ---
    addToCartButton.addEventListener('click', () => {
        addToCartButton.disabled = true;

        const items = [];
        
        // 1. Add the selected Box product first (Small or Large)
        items.push({
            id: selectedBox.id,
            quantity: 1,
            properties: {
                '_BoxType': selectedBox.name,
                '_TotalItems': Array.from(selectedGifts.values()).reduce((sum, item) => sum + item.qty, 0)
            }
        });

        // 2. Add all the selected gift items
        selectedGifts.forEach((item, variantId) => {
            items.push({
                id: variantId,
                quantity: item.qty,
                properties: {
                    '_AddedToBox': selectedBox.name,
                    '_BoxComponent': 'Yes'
                }
            });
        });

        // Use Shopify's AJAX API to add all items at once
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(response => {
             if (response.ok) {
                window.location.href = '/cart';
             } else {
                 return response.json().then(err => Promise.reject(err));
             }
        })
        .catch((error) => {
            console.error('Error adding to cart:', error);
            alert('There was an error adding the box to your cart. Please check the browser console for details.');
            addToCartButton.disabled = false;
        });
    });
});